import React, { useState } from "react";
import { Icon } from "@iconify/react";
import Circle1 from "../../../assets/images/Circle1.svg";
import Circle2 from "../../../assets/images/Circle2.svg";
import logo from "../../../assets/images/admin.svg";
import InputGroup from "../../../components/FormComponent/InputGroup";
import Button from "../../../components/Button/Button";
import { Link } from "react-router-dom";
import styles from "./signUp.module.css";

const ResetPassword = () => {
  const [passwordType, setPasswordType] = useState("password");

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  return (
    <div className={styles.signupcontainer}>
      <div className={styles.forsignup}>
        <div className={styles.container}>
          <div className={`${styles.SecondCircle}`}>
            <img src={Circle2} alt="" />
          </div>
          <div className={`${styles.FirstCircle}`}>
            <img src={Circle1} alt="" />
          </div>
          <div className={`${styles.Random}`}>
            <img src={logo} alt="logo" className="auth-logo" />
          </div>
          <div className={`${styles.maincontainer} auth-form`}>
            <React.Fragment>
              <div className="auth-heading">Reset Password</div>
              <div className="input-padding">
                <InputGroup
                  label="Password"
                  // inputValue={password}
                  inputName="password"
                  placeHolder="Enter Password"
                />
                <div className="password-eye black900">
                  {passwordType === "password" ? (
                    <Icon icon="fluent:eye-16-regular" onClick={togglePassword} />
                  ) : (
                    <Icon icon="iconamoon:eye-off-light" onClick={togglePassword} />
                  )}
                </div>
              </div>
              <div className="input-padding">
                <InputGroup
                  label="New Password"
                  // inputValue={password}
                  inputName="password"
                  placeHolder="Enter Password"
                />
                <div className="password-eye black900">
                  {passwordType === "password" ? (
                    <Icon icon="fluent:eye-16-regular" onClick={togglePassword} />
                  ) : (
                    <Icon icon="iconamoon:eye-off-light" onClick={togglePassword} />
                  )}
                </div>
              </div>
              <div className={`${styles.Footer1}auth-form-buttons input-padding`}>
                <Button buttonName="Login" variant="primary" buttonSize="full"
                  color="btndefault"
                />
              </div>
            </React.Fragment>
            <div className={`${styles.Footer2} auth-account-button input-group-styling input-padding`}>
              Remember password ?
              <Link to="/auth/signup" className="">Go to Login</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
